import React, { useState } from "react";
import "./CallMeDialog.css";
import { useNavigate } from "react-router";
import axios from "axios";
const CallMeDialog = (param) => 
{
  let nav=useNavigate();
  let [formData,setFormData]=useState({edate:"",name:"",mobile:"",details:""});
  function textChange(event)
  {
    if(event.target.id=="name") setFormData({...formData,name:event.target.value});
    if(event.target.id=="mobile")
    {
      if(event.target.value.length<=10)
        setFormData({...formData,mobile:event.target.value});
    }
    if(event.target.id=="details") setFormData({...formData,details:event.target.value});
  }
  function storeData(event)
  {
    event.preventDefault();
    if(formData.name.trim().length<4)
    {
      alert("Invalid Name....");
      document.getElementById("name").focus();
      return;
    }
    if(formData.mobile.trim().length!=10)
    {
      alert("Invalid Mobile....");
      document.getElementById("mobile").focus();
      return;
    }
    if(formData.details.trim().length<10)
    {
      alert("Please Share your problem with us!!");
      document.getElementById("details").focus();
      return;
    }
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',                    
                }
            });  
    let d=new Date(); 
    let data={...formData,edate:d.toISOString().split("T")[0]};   
    apiClient.post("enquiry",data).then(reply=>
    {
      if(reply.status==200 && reply.data.status=="OK")
      {
        nav("/kit1");
      }
    });    
  }
  return (
    <div className="dialog-backdrop">
      <div className="dialog-container">                
        <h4 className="dialog-title">We Will Contact You / हम आपसे संपर्क करेंगे  </h4>       
          <div className="dialog-body">
            <form onSubmit={storeData}>
              <input type="text" onChange={textChange} value={formData.name} id="name" placeholder="Name / नाम " style={{color:'black'}} className="dialog-input mb-1" required />
              <input type="number" maxLength="10" onChange={textChange} value={formData.mobile} id="mobile"  placeholder="Mobile / मोबाइल " style={{color:'black'}} className="dialog-input mb-1" required />
              <textarea id="details" onChange={textChange} value={formData.details} placeholder="Describe your problem / अपनी समस्या बतायें " style={{color:'black'}} className="dialog-textarea" required>
              </textarea>
              <button className="dialog-button">Call Me / मुझसे संपर्क करें</button>
            </form>
        </div>
      </div>
    </div>
  );
};
export default CallMeDialog;
